<div class="flex flex-row items-center name-editor-container">
  <mat-icon
    *ngIf="icon"
    class="material-symbols-rounded mr-2">
    {{ icon }}
  </mat-icon>

  <div class="flex items-center name-editor">
    <ng-container *ngIf="!isEditName">
      <h3 class="product-heading-bold">{{ name }}</h3>

      <mat-icon
        *ngIf="hasEditPrivilege"
        (click)="editName(name)"
        class="material-symbols-rounded fill orange text-base ml-1.5 pointer name-editor-icon">
        mode_edit
      </mat-icon>
    </ng-container>

    <scope-ui-input
      *ngIf="isEditName"
      [autofocus]="true"
      [maximumLength]="255"
      [control]="nameControl"
      (onInputBlurChange)="submitName(name)" />
  </div>
</div>
